import React from 'react';
import { StepContainer } from '../StepContainer';
import { FormSection } from './form/formSection';
import { FormItem } from './form/formItem';

interface CloisonsStepProps {
  data: any;
  onChange: (data: any) => void;
  onNext: () => void;
  onBack: () => void;
}

export const CloisonsStep: React.FC<CloisonsStepProps> = ({
  data = {
    cloisons: {},
    fauxplafonds: {},
    menuiseries: {},
    escaliers: {},
    amenagements: {}
  },
  onChange,
  onNext,
  onBack
}) => {
  const updateSection = (section: string, key: string, value: any) => {
    onChange({
      ...data,
      [section]: {
        ...data[section],
        [key]: value
      }
    });
  };

  return (
    <StepContainer
      title="Cloisons et Aménagements"
      description="Détaillez les travaux de cloisons et d'aménagements intérieurs"
      onNext={onNext}
      onBack={onBack}
    >
      <div className="space-y-6">
        <FormSection
          title="1. Cloisons"
          description="Pose de cloisons intérieures (séparation d'espaces, dressing, etc.)"
        >
          <div className="space-y-4">
            <FormItem
              label="Cloisons en placo-plâtre (sans isolant)"
              value={data.cloisons?.placoplatre || { selected: false }}
              onChange={(value) => updateSection('cloisons', 'placoplatre', value)}
              withSurface
            />
            <FormItem
              label="Cloisons en béton cellulaire (sans isolant)"
              value={data.cloisons?.betonCellulaire || { selected: false }}
              onChange={(value) => updateSection('cloisons', 'betonCellulaire', value)}
              withSurface
            />
            <FormItem
              label="Cloisons en briques (sans isolant)"
              value={data.cloisons?.briques || { selected: false }}
              onChange={(value) => updateSection('cloisons', 'briques', value)}
              withSurface
            />
          </div>
        </FormSection>

        <FormSection
          title="2. Faux-plafonds"
          description="Installation de faux-plafonds"
        >
          <div className="space-y-4">
            <FormItem
              label="Faux-plafond placo-plâtre suspendu"
              value={data.fauxplafonds?.placoSuspendu || { selected: false }}
              onChange={(value) => updateSection('fauxplafonds', 'placoSuspendu', value)}
              withSurface
            />
            <FormItem
              label="Faux-plafond placo-plâtre avec isolation phonique"
              value={data.fauxplafonds?.placoPhonique || { selected: false }}
              onChange={(value) => updateSection('fauxplafonds', 'placoPhonique', value)}
              withSurface
            />
            <FormItem
              label="Besoin d'un échafaudage mobile (hauteur sous plafond > 2,5m)"
              value={data.fauxplafonds?.echafaudageMobile || { selected: false }}
              onChange={(value) => updateSection('fauxplafonds', 'echafaudageMobile', value)}
            />
          </div>
        </FormSection>

        <FormSection
          title="3. Escaliers"
          description="Installation d'escaliers"
        >
          <div className="space-y-4">
            <FormItem
              label="Escalier en bois (nombre de marches)"
              value={data.escaliers?.bois || { selected: false }}
              onChange={(value) => updateSection('escaliers', 'bois', value)}
              withQuantity
            />
            <FormItem
              label="Escalier en béton (nombre de marches)"
              value={data.escaliers?.beton || { selected: false }}
              onChange={(value) => updateSection('escaliers', 'beton', value)}
              withQuantity
            />
            <FormItem
              label="Escalier en métal (nombre de marches)"
              value={data.escaliers?.metal || { selected: false }}
              onChange={(value) => updateSection('escaliers', 'metal', value)}
              withQuantity
            />
            <FormItem
              label="Garde-corps pour escalier"
              value={data.escaliers?.gardeCorps || { selected: false }}
              onChange={(value) => updateSection('escaliers', 'gardeCorps', value)}
              withLength
            />
          </div>
        </FormSection>

        <FormSection
          title="4. Aménagements spécifiques"
          description="Aménagements divers"
        >
          <div className="space-y-4">
            <FormItem
              label="Création d'une mezzanine"
              value={data.amenagements?.mezzanine || { selected: false }}
              onChange={(value) => updateSection('amenagements', 'mezzanine', value)}
              withSurface
            />
            <FormItem
              label="Cloisons mobiles ou amovibles"
              value={data.amenagements?.cloisonsMobiles || { selected: false }}
              onChange={(value) => updateSection('amenagements', 'cloisonsMobiles', value)}
              withSurface
            />
            <FormItem
              label="Installation de verrières intérieures"
              value={data.amenagements?.verriere || { selected: false }}
              onChange={(value) => updateSection('amenagements', 'verriere', value)}
              withSurface
            />
            <FormItem
              label="Installation d'un poêle à bois"
              value={data.amenagements?.poeleBois || { selected: false }}
              onChange={(value) => updateSection('amenagements', 'poeleBois', value)}
            />
            <FormItem
              label="Installation d'une véranda"
              value={data.amenagements?.veranda || { selected: false }}
              onChange={(value) => updateSection('amenagements', 'veranda', value)}
              withSurface
            />
          </div>
        </FormSection>
      </div>
    </StepContainer>
  );
};

export default CloisonsStep;